import React, { useEffect } from 'react';
import './index.scss';
import gifLoader from './ai_waiting_experience_alpha.gif';

interface AIAnimatedLoaderProps {
  isLoading?: boolean;
}

const AIAnimatedLoader: React.FC<AIAnimatedLoaderProps> = ({ isLoading = false }) => {
  // disabling scrollbar while the page is on loading
  useEffect(() => {
    if (!isLoading) {
      return;
    }

    const previousOverflowY = document.body.style.getPropertyValue('overflow-y');
    const previousOverflowYPriority = document.body.style.getPropertyPriority('overflow-y');

    document.body.style.setProperty('overflow-y', 'hidden', 'important');

    return () => {
      if (previousOverflowY) {
        document.body.style.setProperty('overflow-y', previousOverflowY, previousOverflowYPriority || undefined);
      } else {
        document.body.style.removeProperty('overflow-y');
      }
    };
  }, [isLoading]);

  return isLoading ? (
    <div className="aiAnimatedLoader-container">
      <img src={gifLoader} alt="Loading..." className="gif-loader" />
    </div>
  ) : null;
};

export default AIAnimatedLoader;